import type { SVGProps } from "react";
import { cn } from "@/lib/utils";

const GoogleCloud = (props: SVGProps<SVGSVGElement>) => {
  const { className, ...rest } = props;
  return (
    <svg
      className={cn(className)}
      height="1em"
      preserveAspectRatio="xMidYMid"
      viewBox="0 -25 256 256"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="m170.252 56.819 22.253-22.253 1.483-9.37C153.437-11.677 88.976-7.496 52.42 33.92 42.267 45.423 34.734 59.764 30.717 74.573l7.97-1.123 44.505-7.34 3.436-3.513c19.797-21.742 53.27-24.667 76.128-6.168l7.496.39Z"
        fill="#EA4335"
      />
      <path
        d="M224.205 73.918a100.249 100.249 0 0 0-30.217-48.722l-31.232 31.232a55.515 55.515 0 0 1 20.379 44.037v5.544c15.35 0 27.797 12.445 27.797 27.796 0 15.352-12.446 27.485-27.797 27.485h-55.671l-5.466 5.934v33.34l5.466 5.231h55.67c39.93.311 72.553-31.494 72.864-71.424a72.303 72.303 0 0 0-31.793-60.453"
        fill="#4285F4"
      />
      <path
        d="M71.87 205.796h55.593V161.29H71.87a27.275 27.275 0 0 1-11.399-2.498l-7.887 2.42-22.409 22.253-1.952 7.574c12.567 9.489 27.9 14.825 43.647 14.757"
        fill="#34A853"
      />
      <path
        d="M71.87 61.425C31.94 61.664-.237 94.228.001 134.159a72.301 72.301 0 0 0 28.222 56.88l32.248-32.246c-13.99-6.322-20.208-22.786-13.887-36.776 6.32-13.99 22.786-20.208 36.775-13.888a27.796 27.796 0 0 1 13.887 13.888l32.248-32.248A72.224 72.224 0 0 0 71.87 61.425"
        fill="#FBBC05"
      />
    </svg>
  );
};

export default GoogleCloud;
